import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StatusRodadaEnum } from 'src/app/domain/primecap/model/enum/status-rodada.enum';
import { PrimecapUtils } from 'src/app/utils/primecap-utils';
import { EventoTrocaStatus } from '../model/tabela-eventos.model';

@Component({
  selector: 'app-coluna-statuses',
  templateUrl: './coluna-statuses.component.html',
  styleUrls: ['./coluna-statuses.component.css']
})
export class ColunaStatusesComponent {

  // objeto que será exibido na tabela
  @Input() objeto: any;

  // notifica o componente pai de uma mudança no status da rodada de investimento
  @Output() readonly trocaStatus: EventEmitter<EventoTrocaStatus<any>> = new EventEmitter();

  // propriedade usada no HTML representando os status possíveis para rodada de investimento
  readonly statusRodada: typeof StatusRodadaEnum = StatusRodadaEnum;

  constructor() { }

  // permite a exibição do botão 'ON' para troca de status
  exibirBotaoOnAposSucessoRodada(dataTerminoRodada: Date): boolean{
    return PrimecapUtils.calcularDias(dataTerminoRodada) < 6;
  }

  // emite evento de notificação de que o status da rodada de
  // investimento será trocado
  executarTrocaDeStatus(novoStatus: string, objeto: any): void {
    if (!this.trocaStatus) {
      return
    };
    this.trocaStatus.emit({novoStatus, objeto});
  }
}
